import { Group } from '@/components/_common';
import SignatureField from '@/components/_common/SignatureField';
import { uploadArchive } from '@/core/domain/archive/Archive/Archive.service';
import { SubDirectoryEnum } from '@/core/domain/archive/Archive/Archive.types';
import { useCreateSignature } from '@/core/domain/workorder/ChecklistSignature/ChecklistSignature.hooks';
import { useChecklistSignatureWithToken } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import { useDisclosure } from '@/hooks';
import { useQueryParams } from '@/hooks/useQueryParams';
import { isAppPortocar } from '@/index';
import notificationError from '@/utils/functions/notificationError';
import { Button, Image, Space } from 'antd';

const ReportChecklistFooter: React.FC<{ src?: string; isPublic?: boolean }> = ({
  src,
  isPublic = false,
}) => {
  const [viewSignature, setViewSignature] = useDisclosure(false);
  const [loadingSignature, setLoadingSignature] = useDisclosure(false);
  const createSignature = useCreateSignature();
  const checklistSignatureWithToken = useChecklistSignatureWithToken();
  const params = useQueryParams<{
    token?: string;
    workOrderComplementId?: string;
    diagnosticId?: string;
  }>();

  const handleCreateSignature = async (file?: File, extension?: string) => {
    if (file && extension) {
      setLoadingSignature.open();
      try {
        const upload = await uploadArchive({
          file: [file],
          isPublic: false,
          extension: extension,
          subdirectory: SubDirectoryEnum.Signatures,
        });
        setLoadingSignature.close();

        if (isPublic) {
          checklistSignatureWithToken.mutateAsync({
            signature: upload.filePath,
            token: params.token as string,
          });
        } else {
          await createSignature.mutateAsync({
            signature: upload.filePath,
            workOrderComplementId: params.workOrderComplementId
              ? Number(params.workOrderComplementId)
              : undefined,
            diagnosticId: params.diagnosticId
              ? Number(params.diagnosticId)
              : undefined,
          });
        }
      } catch (error) {
        notificationError(error);
      }
    }
  };

  return (
    <div className="reportChecklist-signature">
      {!isAppPortocar && (
        <>
          <p>Declaração</p>
          <p>
            Declaro que retirei todos os objetos e pertences pessoais do veículo
            acima descrito, além de estar ciente que a empresa não se
            responsabiliza pelos pertences que ficarem. Autorizo, caso seja
            necessário, a movimentação deste veículo dentro ou fora da empresa,
            para efetivação de testes de funcionamento e elaboração do
            orçamento.
          </p>
        </>
      )}

      {isAppPortocar && (
        <>
          <div className="reportChecklist-porto-declaration">
            <span>
              O Check-up mecânico Porto Seguro consiste num parecer técnico de
              como o veículo está no momento da avaliação. A Porto Seguro não se
              responsábiliza por itens que não constam como avaliados ou itens
              que não possam ser visualmente checados, e que venham apresentar
              problemas após o diagnóstico.
            </span>
          </div>

          <p>
            Declaro ter retirado do interior do veículo todos os bens e valores
            pessoais não integrados ao automóvel, isentando a Porto Seguro de
            qualquer responsabilidade sobre eventuais itens deixados no veículo.
          </p>
        </>
      )}

      <Space
        style={{ width: '100%', textAlign: 'center', display: 'flex' }}
        direction="vertical"
      >
        {src && (
          <Image
            src={src}
            style={{ maxWidth: '350px', marginTop: 30 }}
            preview={false}
          />
        )}

        {!src && viewSignature && (
          <SignatureField
            isLoading={loadingSignature || createSignature.isLoading}
            onCancel={setViewSignature.close}
            onChange={(sigPadReturn) =>
              handleCreateSignature(sigPadReturn?.file, sigPadReturn?.extension)
            }
          />
        )}

        {!src && !viewSignature && (
          <Button
            type="link"
            className="hidden-print"
            onClick={setViewSignature.open}
          >
            Assinar
          </Button>
        )}

        <div
          className="reportChecklist-signature-field"
          style={{ marginTop: 0 }}
        >
          Assinatura do cliente
        </div>
      </Space>

      <Group position="center" style={{ marginTop: 10 }}>
        <Button className="hidden-print" type="link" onClick={window.print}>
          Imprimir
        </Button>
      </Group>
    </div>
  );
};

export default ReportChecklistFooter;
